import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  Col,
  message,
  Row,
  Segmented,
  Select,
  Typography,
  Modal,
  Card,
  Table,
  Button,
  Spin,
  Empty,
} from "antd";
import styled from "styled-components";
import { EyeOutlined, LoadingOutlined, RightOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";
import TabsList from "molecules/TabsList";
import { Tabs, Space } from "antd";
import { Form, Input } from "antd";
import { getEmailsByRole } from "utils/functions";
import NextAppraisal from "./Nextappraisal";
import { useHistory } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import {
  getLocations,
  getMyTeamPerformanceList,
  getMyTeamPerformanceResponseViewList,
  getUserInfo,
  getUserList,
  getHigherOfficials
} from "redux/selectors";
import {
  CountryTimezone,
  NON_EMPTY_REGEX,
  STATUS_CODE,
} from "common/Constants";
import TextArea from "antd/lib/input/TextArea";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { CALL_API } from "common/API";
import { getLatestReviewedAt, isReEnabledAfterCycleClosed } from "../cycleRules";
import moment from "moment";
import { ReactComponent as TimerClock } from "../../../assets/Timer_clock.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StepsProgress from "organisms/StepsProgress";
import user from "../.../../../../assets/employeeinfo.svg";
import { StyledTable } from "atoms/Table";
import AppraisalHistory from "../AppraisalHistory";
import dayjs from "dayjs";
import axios from "axios";
import { ReactComponent as FolderIcon } from "../../../assets/folder.svg";
import { ReactComponent as FolderIconYellow } from "../../../assets/icons/FolderIcon.svg";
import { EmployeeInfo } from "../EmployeeInfo";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { ContainerContext } from "pages/Container";
dayjs.extend(timezone);
dayjs.extend(utc);
const { Option } = Select;

const { Text } = Typography;

const Wrap = styled.div`
  .score-classification {
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    text-decoration: underline;
    color: #126df6;
  }
`;

const Tabledata = styled.div`
  .cursor-pointer {
    cursor: pointer;
  }
  .wrapped-header {
    white-space: normal !important;
  }

  .appraisal_container_mainone {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  .Appraisal_first_tabledata {
    display: flex;
    gap: 10px;
  }
  .primary_adition_adition2 {
    background-color: rgb(254, 254, 255);
    padding: 4px 4px 4px 4px;
    width: 30%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .primary_adition_adition2 {
    background-color: rgb(254, 254, 255);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.08),
      0px 6px 12px rgba(0, 0, 0, 0.06), 0px 8px 16px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 2px 12px 2px 12px;
  }
  .tab_itemone {
    background-color: rgb(194, 250, 229);
    font-size: 16px;
    font-weight: 300;
    padding: 4px 9px 6px 9px;
  }
  .customCheckbox .ant-checkbox-inner {
    border-radius: 8px;
    border-color: lightgrey;
    border: none;
    outline: none;
  }
  .customCheckbox .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #4caf50;
    border: none;
    outline: none;
  }
  .customCheckbox .ant-checkbox-inner::after {
    background-color: white;
    border: none;
    outline: none;
  }
  .appraisalTitle {
    font-size: 15px;
    font-weight: 600;
    color: rgb(138, 143, 160);
  }
  .appraisalSubTitle {
    font-size: 15px;
    color: rgb(138, 143, 160);
  }
  .Right_outlined {
    font-size: 15px;
    color: rgb(138, 143, 160);
  }
  .paragraph_response {
    margin: 25px 0px 10px 0px;
  }
  .Response_new_paragraph {
    color: #1f243b;
    font-size: 20px;
    font-weight: 500;
  }
  .header_container {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
    background-color: rgb(255, 255, 255);
    border-radius: 20px;
  }

  .main_wrapper_ {
    display: flex;
    width: 45%;
  }
  .content_area_ {
    width: 60%;
    font-size: 14px;
    font-weight: 500;
  }
  .content_area_two {
    width: 40%;
    font-size: 14px;
    font-weight: 500;
  }
  .Individual_Assessment {
    color: #1f243b;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .assessment_wrapper {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 0;
    justify-content: space-between;
  }
  .assessment_item {
    display: flex;
    width: 45%;
  }
  .assessment_label {
    width: 60%;
    font-size: 14px;
  }
  .assessment_value {
    width: 40%;
    font-size: 14px;
    font-weight: 500;
  }
  .Departmental_Country_Cluster {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
    margin-top: 5px;
  }
  .assessment_container {
    display: flex;
    border-radius: 20px;
    margin: 45px 0px 0px 0px;
    background-color: rgb(248, 248, 248);
    padding: 25px 15px 25px 15px;
  }
  .assessment_container_one {
    width: 45%;
  }

  .assessment_score {
    display: flex;
    width: 100%;
  }

  .assessment_input_score {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .assessment_remark {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .custom-label {
    color: #636980;
    font-size: 14px;
    font-weight: 500;
  }
  .score-card {
    background: #f8f8f8;
    padding: 10px;
  }
  .value-common {
    font-size: 14px;
    font-weight: 400;
  }
  .heading {
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    padding-left: 8px;
    color: #636980;
  }
  .score {
    font-size: 16px;
    font-weight: 400;
  }
  .custom-item1 {
    display: flex;
    gap: 20px;
  }
`;
const TabItem = styled.div`
  cursor: pointer;
  background-color: ${(props) => (props.active ? "rgb(194,250,229)" : "white")};
  color: ${(props) => (props.active ? "black" : "black")};
  border-radius: 4px;
  margin-right: 10px;
  padding: 4px 5px 4px 5px;
`;

const SegmentWrap = styled(Segmented)`
  position: sticky;
  top: 40px;
  float: right;
  background-color: #fff;
  z-index: 100;
  border: 1px solid #ffffff;
  color: #636980;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  .ant-segmented-item-selected {
    background-color: #c2fae5 !important;
    color: black;
  }
`;

const ButtonCancel = styled(Button)`
  padding: 5px 20px;
  border-radius: 5px;
  background: transparent;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
  margin: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add shadow effect */

  &:hover {
    background: transparent; /* No background change */
    color: #000000; /* No color change */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Keep original shadow */
    border: none; /* Remove any border */
    outline: none; /* Remove the blue outline */
  }

  &:focus {
    background: #f1f3f4;
    color: #000000;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Shadow on focus */
    border: none; /* Remove any border */
    outline: none; /* Remove the blue outline */
  }

  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-title {
    font-size: 18px;
    font-weight: bold;
  }
  .item-score {
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
    color: black;
  }
  .item-description {
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
    color: black;
  }
  .modal-title {
    font-weight: 600;
    font-size: 18px;
  }
  .role-title {
    font-weight: 400;
    font-size: 16px;
  }
  .ant-modal-content {
    border-radius: 8px !important;
  }
  .ant-modal-footer {
    border-top: none !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  .cancel-modal-button {
    width: 83px;
    height: 34px;
    border: none;
    font-weight: 400;
    font-size: 16px;
  }
  .discard-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #1f243b;
    font-weight: 400;
    font-size: 16px;
  }
  .save-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #c2fae5;
    font-weight: 400;
    font-size: 16px;
  }
  .modal-text {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
    margin-bottom: 0;
  }
  .circle-warning-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .tick-created {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .created-text {
    font-weight: 400;
    font-size: 18px;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: black !important;
  }
  .ant-tabs-ink-bar {
    background-color: black !important;
  }
  .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: black !important;
  }
`;

const Sectiontitle = styled.section`
  font-weight: 500;
  font-size: 16px;
  padding-bottom: 10px;
`;

const StyledSpan = styled.span`
  color: #636980;
  font-size: 14px;
  font-weight: 400;
`;

const AppraisalForm = ({ appraisalDetails }) => {
  const Listofitems = [
    {
      key: 1,
      label: <span className="custom-label">Client Survey Average Score</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.clientsurveyscore ||
            "-"}
        </span>
      ),
    },
    {
      key: 2,
      label: (
        <span className="custom-label">Engagement Appraisal Average Score</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]
            ?.engagementappraisalscore || "-"}
        </span>
      ),
    },
    {
      key: 3,
      label: <span className="custom-label">VTP Appraisal Average Score</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.vtpappraisalscore ||
            "-"}
        </span>
      ),
    },
    {
      key: 4,
      label: <span className="custom-label">Leaves Taken (Days)</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.leavetakendays || "-"}
        </span>
      ),
    },
    {
      key: 5,
      label: (
        <span className="custom-label">LMS - 40 hrs (target to actual %)</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.lmstarget || "-"}
        </span>
      ),
    },
    {
      key: 6,
      label: (
        <span className="custom-label">Chargeability (target to actual %)</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.chargeability || "-"}
        </span>
      ),
    },
    {
      key: 7,
      label: <span className="custom-label">Non- Chargeable %</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.nonchargeable || "-"}
        </span>
      ),
    },
    {
      key: 8,
      label: <span className="custom-label">CV last Updated (Date)</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.cvlastupdateddate
            ? moment(
              appraisalDetails?.individualassessment?.[0]?.cvlastupdateddate
            ).format("DD-MM-YYYY")
            : "-"}
        </span>
      ),
    },
    {
      key: 9,
      label: <span className="custom-label">No. of credentials inputted</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]
            ?.noofcredentialsinputted || "-"}
        </span>
      ),
    },
    {
      key: 10,
      label: (
        <span className="custom-label">Avg Time-sheet delays in days</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.avgtimesheetdelaydays ||
            "-"}
        </span>
      ),
    },
    {
      key: 11,
      label: (
        <span className="custom-label">
          Avg Time-sheet approval delays in days
        </span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]
            ?.avgtimesheetapprovedelaydays || "-"}
        </span>
      ),
    },
    {
      key: 12,
      label: (
        <span className="custom-label">Avg Task delays in Days (VTP)</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.avgtaskdelaydays || "-"}
        </span>
      ),
    },
    {
      key: 13,
      label: <span className="custom-label">No. of assignments worked on</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.noofassignmentsworked ||
            "-"}
        </span>
      ),
    },
    {
      key: 14,
      label: <span className="custom-label">Employee Billing</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.employeebilling || "-"}
        </span>
      ),
    },
    {
      key: 15,
      label: <span className="custom-label">Employee Profit/ Loss</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.employeeprofitloss ||
            "-"}
        </span>
      ),
    },
    {
      key: 16,
      label: (
        <span className="custom-label">
          Amounts of Proposal in the pipeline
        </span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.amountsofproposal ||
            "-"}
        </span>
      ),
    },
    {
      key: 17,
      label: <span className="custom-label">No. of leads Created</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.noofleads || "-"}
        </span>
      ),
    },
    {
      key: 18,
      label: (
        <span className="custom-label">Proposal Conversion Rates (%)</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]
            ?.proposalconversionrate || "-"}
        </span>
      ),
    },
  ];

  const itemstwo = [
    {
      key: 1,
      label: (
        <span className="custom-label">Revenue, Rev vs budget, and GOLY %</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.clusterlevel?.[0]?.revenue || "-"}
        </span>
      ),
    },

    {
      key: 2,
      label: (
        <span className="custom-label">
          Departmental Profit, vs budget, GOLY%
        </span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.clusterlevel?.[0]?.departmentprofit || "-"}
        </span>
      ),
    },

    {
      key: 3,
      label: <span className="custom-label">Rev/ Profit per employee</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.clusterlevel?.[0]?.employeeprofit || "-"}
        </span>
      ),
    },

    {
      key: 4,
      label: (
        <span className="custom-label">
          Employee cost, Profits as a %age of rev
        </span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.clusterlevel?.[0]?.employeecost || "-"}
        </span>
      ),
    },

    {
      key: 5,
      label: (
        <span className="custom-label" style={{ paddingRight: "0px" }}>
          Debtors in USD and days
        </span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.clusterlevel?.[0]?.debtors || "-"}
        </span>
      ),
    },
  ];

  return (
    <Tabledata>
      <div className="Individual_Assessment">Individual Assessment</div>
      <div className="header_container">
        {Listofitems?.map(function (item, index) {
          return (
            <>
              <div className="main_wrapper_" key={index}>
                <p className="content_area_">{item?.label}</p>
                <p className="content_area_two">{item?.value}</p>
              </div>
            </>
          );
        })}
      </div>
      <div className="Individual_Assessment">
        Departmental/ Country/ Cluster level assessment
      </div>
      <div className="header_container">
        {itemstwo?.map(function (item, index) {
          return (
            <>
              <div className="main_wrapper_" key={index}>
                <p className="content_area_">{item?.label}</p>
                <p className="content_area_two">{item?.value}</p>
              </div>
            </>
          );
        })}
      </div>
    </Tabledata>
  );
};

const Viewmytabledata = ({ userList, userInfo }) => {
  const { layoutContentRef } = useContext(ContainerContext);
  const { id, tabId: activeTabId } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [allAppraisalData, setAllAppraisalData] = useState([]);
  const [appraisalDetails, setAppraisalDetails] = useState({});
  const [loader, setLoader] = useState(false);
  const [formValues, setFormValues] = useState([]);
  const [segmentedData, setSegmentData] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [isScoreModal, setIsScoreModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  // Add this state at the top inside Attend component
  const [objectiveModal, setObjectiveModal] = useState({
    open: false,
    objective: null,
    contract: null,
  });
  const [modalLoading, setModalLoading] = useState(false);
  const [loadingnew, setLoadingnew] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const higherOfficialsList = useSelector(getHigherOfficials);
  const CEO = getEmailsByRole(higherOfficialsList, "CEO");

  const location = useLocation();
  const roletype = location.state?.roletype;
  const data = location.state?.data;
  const appraisalRecords = location.state?.appraisalRecord;
  const isView = location.state?.isView || false;
  const isMyTeam = location.state?.isMyTeam || false;

  // Helper for modal config
  const getObjectiveModalConfig = (objective) => {
    switch (objective) {
      case "Strategic / Target Objectives":
        return {
          title: "Strategic objectives",
          secondCol:
            "Strategic objectives aligned to Organizational Strategy for the upcoming appraisal period",
        };
      case "Actions expected from previous Appraisal":
        return {
          title: "Rollover Responsibility from Previous Appraisal",
          secondCol:
            "Objectives that Rolled Over from Previous Appraisal Period",
        };
      case "Key responsibilities (from job descriptions)":
        return {
          title: "Objectives from JD for the Current Appraisal Period",
          secondCol:
            "Target objectives aligned to Organizational Strategy for the current appraisal period",
        };
      case "Additional Roles/ Backstopping Roles":
        return {
          title: "Objectives from JD for the Current Appraisal Period",
          secondCol:
            "Target objectives aligned to Organizational Strategy for the Current appraisal period",
        };
      default:
        return {
          title: "",
          secondCol: "",
        };
    }
  };

  // Helper for mapping API data to modal table
  const getObjectiveDataFromContract = (objective, contract) => {
    switch (objective) {
      case "Strategic / Target Objectives":
        return (contract?.startegicobjectives || []).map((item, idx) => ({
          sno: idx + 1,
          main: item.straobjorgstartegy,
          expectedoutcome: item.expectedoutcome,
          targetdate: item.TargetDate,
          weightage: item.Weightage,
        }));
      case "Actions expected from previous Appraisal":
        return (contract?.rolloverresponsibility || []).map((item, idx) => ({
          sno: idx + 1,
          main: item.previousappraisalperiod,
          expectedoutcome: item.expectedoutcome,
          targetdate: item.TargetDate,
          weightage: item.Weightage,
        }));
      case "Additional Roles/ Backstopping Roles":
        return (contract?.upcomingappraisalperiod || []).map((item, idx) => ({
          sno: idx + 1,
          main: item.upcomingappraisalperiod,
          expectedoutcome: item.expectedoutcome,
          targetdate: item.TargetDate,
          weightage: item.Weightage,
        }));
      case "Key responsibilities (from job descriptions)":
        return (contract?.upcomingappraisalperiod || []).map((item, idx) => ({
          sno: idx + 1,
          main: item.upcomingappraisalperiod,
          expectedoutcome: item.expectedoutcome,
          targetdate: item.TargetDate,
          weightage: item.Weightage,
        }));
      default:
        return [];
    }
  };
  const scoreData = [
    { score: "6", description: "Exceptional performance", color: "#03C83E" },
    {
      score: "5",
      description: "Exceeds minimum requirements",
      color: "#7DCA4ACC",
    },
    {
      score: "4",
      description: "Meets all minimum requirements",
      color: "#FFFF68",
    },
    {
      score: "3",
      description: "Typically meets minimum requirements",
      color: "#ED7D31CC",
    },
    {
      score: "2",
      description: "Does not meet minimum requirements",
      color: "#FF0000CC",
    },
    { score: "1", description: "Unacceptable performance", color: "#C00000CC" },
  ];
  const myteamperformanceresponseviewlist = useSelector(
    getMyTeamPerformanceResponseViewList
  );

  let myteamPerformanceList = useSelector(getMyTeamPerformanceList);
  const history = useHistory();
  const appraisalRecord = history?.location?.state?.appraisalRecord || {};
  const isEdit = history?.location?.state?.isEdit || false;
  const tab = activeTabId === "1" ? "newresponse" : "evaluate";

  const [technicalAssessmentData, setTechnicalAssessmentData] = useState([]);
  const [technicalAssessmentTable, setTechnicalAssessmentTable] = useState(
    appraisalDetails?.technicalassessment
  );
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const locationList = useSelector(getLocations);

  const filterLevelLocationName = locationList?.find(
    (item) => item.location_id === selectedEmployee?.levellocationid
  );

  const [bdoValuesTable, setBdoValuesTable] = useState(
    appraisalDetails?.rolledovernextappraisal
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => setIsModalVisible(true);
  const handleCancelModal = () => setIsModalVisible(false);

  const findUser = userList?.find(
    (item) => item?.userid === appraisalDetails?.appraiseemailid
  );

  const [validationErrors, setValidationErrors] = useState({});
  const getData = async () => {
    const { code, response, performanceContractList } = await CALL_API(
      `appraisal/history?appraiseemailid=${appraisalRecord?.apraiseemailid || appraisalRecord?.userid
      }`,
      "get",
      {}
    );
    if (code === STATUS_CODE?.SUCCESS) {
      setHistoryData(performanceContractList);
    }
  };

  const handleChange = (value, record, field) => {
    // Update data
    const updatedData = technicalAssessmentData.map((item) => {
      if (item.id === record.id) {
        return { ...item, [field]: value };
      }
      return item;
    });

    setTechnicalAssessmentData(updatedData);

    // Clear error for this field if it was previously invalid
    if (validationErrors?.[record.id]?.[field]) {
      const updatedErrors = { ...validationErrors };

      delete updatedErrors[record.id][field];

      // Clean up empty nested objects
      if (Object.keys(updatedErrors[record.id]).length === 0) {
        delete updatedErrors[record.id];
      }

      setValidationErrors(updatedErrors);
    }
  };
  const columns = [
    {
      title: "Objectives",
      dataIndex: "objectives",
      key: "objectives",
      render: (text, record) => {
        return (
          <span
            style={{ color: "#0066FF", cursor: "pointer" }}
            onClick={async () => {
              setModalLoading(true);
              setLoadingnew(true);
              try {
                const roletype = appraisalDetails?.appraiseeroletype;
                const res = await CALL_API(
                  `appraisal/appraiseemine?userid=${appraisalDetails.appraiseemailid}`,
                  "get"
                );
                if (res?.code === "SUCCESS") {
                  const contractList = Array.isArray(
                    res.performanceContractList
                  )
                    ? res.performanceContractList
                    : [];
                  const contract = contractList.find(
                    (item) => item?.contractid === appraisalDetails?.contractid
                  );

                  if (contract) {
                    setObjectiveModal({
                      open: true,
                      objective: text,
                      contract,
                    });
                  } else {
                    message.error(
                      `No contract found for this role. roletype searched: "${appraisalRecords?.appraisalInformation[0]?.roletype ||
                      data?.type
                      }"`
                    );
                  }
                } else {
                  message.error("Failed to fetch contract data.");
                }
              } catch (error) {
                message.error("Failed to fetch contract data.");
              } finally {
                setModalLoading(false);
                setLoadingnew(false);
              }
            }}
          >
            {text}
          </span>
        );
      },
    },

    {
      title: "What went well/Major achievement",
      dataIndex: "whatwentwellmajorachivement",
      key: "whatwentwellmajorachivement",
      className: "wrapped-header",
      width: "30%",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "What can be improved / Challenges",
      dataIndex: "whatdidnotgowellchallenges",
      key: "whatdidnotgowellchallenges",
      className: "wrapped-header",
      width: "30%",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Self Score",
      dataIndex: "selfscore",
      key: "selfscore",
      align: "center",
      width: "10%",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Appraiser's score",
      dataIndex: "appraiserscore",
      key: "appraiserscore",
      render: (text, record) => (
        <Select
          placeholder="Select score"
          value={record.appraiserscore}
          onChange={(value) => handleChange(value, record, "appraiserscore")}
          style={{
            width: "100%",
            border: validationErrors?.[record.id]?.appraiserscore
              ? "1px solid red"
              : undefined,
          }}
          disabled={
            appraisalDetails?.appraisarmailid !== userInfo?.userid ||
            ((!allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) ||
              appraisalDetails?.appraiseemailid === userInfo?.userid) &&
              userInfo?.userid !== CEO)
          }
        >
          {[1, 2, 3, 4, 5, 6].map((score) => (
            <Option key={score} value={score}>
              {score}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Appraiser's Remark",
      dataIndex: "appraiserremark",
      key: "appraiserremark",
      className:
        allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) ||
          appraisalDetails?.appraiseemailid !== userInfo?.userid
          ? ""
          : "wrapped-header",
      width: "30%",
      render: (text, record) =>
        allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) ||
          appraisalDetails?.appraiseemailid !== userInfo?.userid ? (
          <Input.TextArea
            autoSize={{ minRows: 1, maxRows: 6 }}
            placeholder="Enter..."
            value={record.appraiserremark}
            onChange={(e) =>
              handleChange(e.target.value, record, "appraiserremark")
            }
            disabled={
              appraisalDetails?.appraisarmailid !== userInfo?.userid ||
              ((!allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) ||
                appraisalDetails?.appraiseemailid === userInfo?.userid) &&
                userInfo?.userid !== CEO)
            }
            style={{
              width: "100%",
              border: validationErrors?.[record.id]?.appraiserremark
                ? "1px solid red"
                : undefined,
            }}
          />
        ) : (
          text || "-"
        ),
    },
  ];

  const viewJobDescription = async () => {
    if (
      !userAppraisalInfo[0]?.jobDescriptionId ||
      !userAppraisalInfo[0]?.jobdescriptionFileName
    ) {
      message.warning("User has not created a Job Description.");
      return;
    }
    const token = window.localStorage.getItem("token") || "";
    try {
      setLoader(true);
      const response = await axios.get(
        "https://axcxv4d066.execute-api.ap-south-1.amazonaws.com/Prod/appraisal/getdocument",
        {
          params: {
            jobdescriptionid: userAppraisalInfo[0]?.jobDescriptionId,
            filename: userAppraisalInfo[0]?.jobdescriptionFileName,
          },
          headers: { Insytsjwt: token },
        }
      );
      if (response?.data?.status === "SUCCESS" && response?.data?.url) {
        setPdfUrl(response.data.url);
        setIsPdfModalOpen(true);
      } else {
        message.error(response?.data?.message || "Failed to fetch document.");
        setLoader(false);
      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch document.");
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const [softSkillData, setSoftSkillData] = useState([]);
  const [validationDataErrors, setValidationDataErrors] = useState({});

  const handleDataValidation = () => {
    const errors = {};
    let isValid = true;

    softSkillData.forEach((record) => {
      const {
        id,
        whatwentwellmajorachivement,
        whatdidnotgowellchallenges,
        selfscore,
        appraiserscore,
        appraiserremark,
      } = record;

      if (!errors[id]) errors[id] = {};

      if (!whatwentwellmajorachivement) {
        errors[id].whatwentwellmajorachivement = true;
        isValid = false;
      }

      if (!whatdidnotgowellchallenges) {
        errors[id].whatdidnotgowellchallenges = true;
        isValid = false;
      }

      if (!selfscore) {
        errors[id].selfscore = true;
        isValid = false;
      }

      if (!appraiserscore) {
        errors[id].appraiserscore = true;
        isValid = false;
      }

      if (!appraiserremark) {
        errors[id].appraiserremark = true;
        isValid = false;
      }
    });

    setValidationDataErrors(errors);

    if (!isValid) {
      message.error("Please fill in all required soft skill fields.");
    }

    return isValid;
  };

  const handleValidation = () => {
    const errors = {};
    let isValid = true;

    technicalAssessmentData.forEach((record) => {
      const {
        id,
        whatwentwellmajorachivement,
        whatdidnotgowellchallenges,
        selfscore,
        appraiserscore,
        appraiserremark,
      } = record;

      if (!errors[id]) errors[id] = {};

      if (!whatwentwellmajorachivement) {
        errors[id].whatwentwellmajorachivement = true;
        isValid = false;
      }

      if (!whatdidnotgowellchallenges) {
        errors[id].whatdidnotgowellchallenges = true;
        isValid = false;
      }

      if (!selfscore) {
        errors[id].selfscore = true;
        isValid = false;
      }

      if (!appraiserscore) {
        errors[id].appraiserscore = true;
        isValid = false;
      }

      if (!appraiserremark) {
        errors[id].appraiserremark = true;
        isValid = false;
      }
    });

    setValidationErrors(errors);

    if (!isValid) {
      message.error("Please fill in all required technical assessment fields.");
    }

    return isValid;
  };

  const handleDataChange = (value, record, field) => {
    // Update data
    const updatedData = softSkillData.map((item) =>
      item.id === record.id ? { ...item, [field]: value } : item
    );
    setSoftSkillData(updatedData);

    // Clear validation error for that field if present
    const updatedErrors = { ...validationDataErrors };
    const fieldPath = updatedErrors?.[record.id];

    if (fieldPath?.[field]) {
      delete fieldPath[field];
      if (Object.keys(fieldPath).length === 0) {
        delete updatedErrors[record.id];
      }
      setValidationDataErrors(updatedErrors);
    }
  };

  const columns1 = [
    {
      title: "Objectives",
      dataIndex: "objective",
      key: "objective",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Weightage(%)",
      dataIndex: "weightage",
      key: "weightage",
      align: "center",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "What went well/Major achievement",
      dataIndex: "whatwentwellmajorachivement",
      key: "whatwentwellmajorachivement",
      className: "wrapped-header",
      width: "30%",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "What can be improved / Challenges",
      dataIndex: "whatdidnotgowellchallenges",
      key: "whatdidnotgowellchallenges",
      className: "wrapped-header",
      width: "30%",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Self Score",
      dataIndex: "selfscore",
      key: "selfscore",
      align: "center",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Appraiser's score",
      dataIndex: "appraiserscore",
      key: "appraiserscore",
      width: "10%",
      render: (text, record) => (
        <Select
          placeholder="Select score"
          value={record.appraiserscore}
          onChange={(value) =>
            handleDataChange(value, record, "appraiserscore")
          }
          style={{
            width: "100%",
            border: validationDataErrors?.[record.id]?.appraiserscore
              ? "1px solid red"
              : undefined,
          }}
          disabled={
            appraisalDetails?.appraisarmailid !== userInfo?.userid ||
            ((!allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) ||
              appraisalDetails?.appraiseemailid === userInfo?.userid) &&
              userInfo?.userid !== CEO)
          }
        >
          {[1, 2, 3, 4, 5, 6].map((score) => (
            <Option key={score} value={score}>
              {score}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Appraiser's Remark",
      dataIndex: "appraiserremark",
      key: "appraiserremark",
      className:
        allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) ||
          appraisalDetails?.appraiseemailid !== userInfo?.userid
          ? ""
          : "wrapped-header",
      width: "40%",
      render: (text, record) => (
        <>
          {allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) ||
            appraisalDetails?.appraiseemailid !== userInfo?.userid ? (
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 6 }}
              placeholder="Enter..."
              value={record.appraiserremark}
              onChange={(e) =>
                handleDataChange(e.target.value, record, "appraiserremark")
              }
              disabled={
                appraisalDetails?.appraisarmailid !== userInfo?.userid ||
                ((!allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) ||
                  appraisalDetails?.appraiseemailid === userInfo?.userid) &&
                  userInfo?.userid !== CEO)
              }
              style={{
                width: "100%",
                border: validationDataErrors?.[record.id]?.appraiserremark
                  ? "1px solid red"
                  : undefined,
              }}
            />
          ) : (
            text || "-"
          )}
        </>
      ),
    },
  ];

  const [rolledOverData, setRolledoverData] = useState([]);
  const [validationRollOverErrors, setValidationRoleOverErrors] = useState({});

  const [appraisarGrowthValidationErrors, setAppraisarGrowthValidationErrors] =
    useState({});

  const appraiserGrowthData = [
    {
      id: 1,
      category: "Career changes",
      low: false,
      moderate: false,
      high: false,
      options: [
        "Demotion/ transfer",
        "Retention in same job grade",
        "Promotion (to a higher job grade)",
      ],
      // selectedOption: "Demotion/ transfer",
      remarks: "",
    },
    {
      id: 2,
      category: "Training needs",
      low: false,
      moderate: false,
      high: false,
      options: ["Low / None", "Moderate", "High / PIP"],
      remarks: "",
    },
    {
      id: 3,
      category: "Bonus",
      low: false,
      moderate: false,
      high: false,
      options: ["Low / None", "Moderate", "High"],
      remarks: "",
    },
    {
      id: 4,
      category: "Salary changes",
      low: false,
      moderate: false,
      high: false,
      options: ["Low / None", "Moderate", "High"],
      remarks: "",
    },
  ];
  const [appraiseeGrowthData, setAppraiseeGrowthData] =
    useState(appraiserGrowthData);

  const InitialScore = 0;

  const InitialTotal = 0;

  const UpdatedDate = "";

  const UpdatedBy = "";

  const Listofitems = [
    {
      key: 1,
      label: <span className="custom-label">Client Survey Average Score</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.clientsurveyscore ||
            "-"}
        </span>
      ),
    },
    {
      key: 2,
      label: (
        <span className="custom-label">Engagement Appraisal Average Score</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]
            ?.engagementappraisalscore || "-"}
        </span>
      ),
    },
    {
      key: 3,
      label: <span className="custom-label">VTP Appraisal Average Score</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.vtpappraisalscore ||
            "-"}
        </span>
      ),
    },
    {
      key: 4,
      label: <span className="custom-label">Leaves Taken (Days)</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.leavetakendays || "-"}
        </span>
      ),
    },
    {
      key: 5,
      label: (
        <span className="custom-label">LMS - 40 hrs (target to actual %)</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.lmstarget || "-"}
        </span>
      ),
    },
    {
      key: 6,
      label: (
        <span className="custom-label">Chargeability (target to actual %)</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.chargeability || "-"}
        </span>
      ),
    },
    {
      key: 7,
      label: <span className="custom-label">Non- Chargeable %</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.nonchargeable || "-"}
        </span>
      ),
    },
    {
      key: 8,
      label: <span className="custom-label">CV last Updated (Date)</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.cvlastupdateddate
            ? moment(
              appraisalDetails?.individualassessment?.[0]?.cvlastupdateddate
            ).format("DD-MM-YYYY")
            : "-"}
        </span>
      ),
    },
    {
      key: 9,
      label: <span className="custom-label">No. of credentials inputted</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]
            ?.noofcredentialsinputted || "-"}
        </span>
      ),
    },
    {
      key: 10,
      label: (
        <span className="custom-label">Avg Time-sheet delays in days</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.avgtimesheetdelaydays ||
            "-"}
        </span>
      ),
    },
    {
      key: 11,
      label: (
        <span className="custom-label">
          Avg Time-sheet approval delays in days
        </span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]
            ?.avgtimesheetapprovedelaydays || "-"}
        </span>
      ),
    },
    {
      key: 12,
      label: (
        <span className="custom-label">Avg Task delays in Days (VTP)</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.avgtaskdelaydays || "-"}
        </span>
      ),
    },
    {
      key: 13,
      label: <span className="custom-label">No. of assignments worked on</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.noofassignmentsworked ||
            "-"}
        </span>
      ),
    },
    {
      key: 14,
      label: <span className="custom-label">Employee Billing</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.employeebilling || "-"}
        </span>
      ),
    },
    {
      key: 15,
      label: <span className="custom-label">Employee Profit/ Loss</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.employeeprofitloss ||
            "-"}
        </span>
      ),
    },
    {
      key: 16,
      label: (
        <span className="custom-label">
          Amounts of Proposal in the pipeline
        </span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.amountsofproposal ||
            "-"}
        </span>
      ),
    },
    {
      key: 17,
      label: <span className="custom-label">No. of leads Created</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]?.noofleads || "-"}
        </span>
      ),
    },
    {
      key: 18,
      label: (
        <span className="custom-label">Proposal Conversion Rates (%)</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.individualassessment?.[0]
            ?.proposalconversionrate || "-"}
        </span>
      ),
    },
  ];

  const itemstwo = [
    {
      key: 1,
      label: (
        <span className="custom-label">Revenue, Rev vs budget, and GOLY %</span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.clusterlevel?.[0]?.revenue || "-"}
        </span>
      ),
    },

    {
      key: 2,
      label: (
        <span className="custom-label">
          Departmental Profit, vs budget, GOLY%
        </span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.clusterlevel?.[0]?.departmentprofit || "-"}
        </span>
      ),
    },

    {
      key: 3,
      label: <span className="custom-label">Rev/ Profit per employee</span>,
      value: (
        <span className="value-common">
          {appraisalDetails?.clusterlevel?.[0]?.employeeprofit || "-"}
        </span>
      ),
    },

    {
      key: 4,
      label: (
        <span className="custom-label">
          Employee cost, Profits as a %age of rev
        </span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.clusterlevel?.[0]?.employeecost || "-"}
        </span>
      ),
    },

    {
      key: 5,
      label: (
        <span className="custom-label" style={{ paddingRight: "0px" }}>
          Debtors in USD and days
        </span>
      ),
      value: (
        <span className="value-common">
          {appraisalDetails?.clusterlevel?.[0]?.debtors || "-"}
        </span>
      ),
    },
  ];

  const [tabId, setTabId] = useState(1);
  const [myTeamViewTab, setMyTeamViewTab] = useState("basic");

  const stepdata = [
    { id: 1, title: "Basic Evaluation" },
    { id: 2, title: "Recommendations" },
  ];

  const items = useMemo(() => {
    const baseItems = [
      {
        label: "Basic Evaluation",
        id: 1,
        children: <></>,
      },
    ];

    if (appraisalDetails?.appraisarmailid === userInfo?.userid) {
      baseItems.push({
        label: "Recommendations",
        id: 2,
        children: <></>,
      });
    }

    return baseItems;
  }, [appraisalDetails?.appraisarmailid, userInfo?.userid]);

  useEffect(() => {
    // If user is not appraiser and somehow on tab 2, redirect to tab 1
    if (tabId === 2 && appraisalDetails?.appraisarmailid !== userInfo?.userid) {
      setTabId(1);
    }
  }, [tabId, appraisalDetails?.appraisarmailid, userInfo?.userid]);

  const handleTabSelect = (key) => {
    setTabId(key);
  };

  //evaluation page

  const dataSource = [
    {
      id: 1,
      previousObjectives: "",
      expectedOutcomes: "",
      targetDate: "",
      remedialActions: "",
      actiontargetdate: "",
      actionoxpectedoutcomes: "",
    },
  ];

  //next appraisal------------------------------------------------------------------

  const nextAppraisalDataSource = [
    {
      id: 1,
      targetobjectives: "",
      expectedoutcomes: "",
      targetdate: "",
      remedialactions: "",
      actionoxpectedoutcomes: "",
      actiontargetdate: "",
    },
  ];

  const scrollRef = useRef(null);

  const getDetails = async () => {
    setLoading(true);
    const appraiseeId =
      appraisalRecord?.apraiseemailid || appraisalRecord?.userid;
    const { code, response, performanceContractList } = await CALL_API(
      `appraisal/appraisarreview?appraiseemailid=${appraiseeId}`,
      "get",
      {}
    );
    // Roster change-log (Postgres, always fresh) — needed to tell a role that
    // was DELETED-then-RE-ADDED after this cycle closed apart from one that
    // genuinely belongs to it. The live roster alone can't: a re-added role is
    // active again, so it passes the liveRoster filter and — because it's still
    // frozen into this cycle's contract snapshot — renders a blank placeholder
    // tab for a role that never had a contract here. See cycleRules.
    let rosterHistoryList = [];
    try {
      const historyRes = await CALL_API(
        `appraisal/appraisalhisorty?userid=${appraiseeId}`,
        "get",
        {}
      );
      rosterHistoryList = historyRes?.historyList || [];
    } catch (e) {
      rosterHistoryList = [];
    }
    if (code === STATUS_CODE?.SUCCESS) {
      // ✅ Use all records — don't filter by appraiserid
      setAllAppraisalData(performanceContractList);

      const filtered = performanceContractList?.filter(
        (item) => item?.contractid === appraisalRecord?.contractid
      );

      // Scope the whole tab set to the SPECIFIC cycle of the record you
      // clicked — not that role's overall latest cycle (a role can advance
      // to a later cycle while you're still viewing an older, closed one;
      // scoping by role-max wrongly jumped the whole page to the later cycle).
      const filteredReference = performanceContractList?.filter(
        (item) => item?.performanceid === appraisalRecord?.performanceid
      );

      const contractSource = isEdit ? filtered : filteredReference;

      // Scenario 1: cycle still ongoing (some configured role not yet
      // created/reviewed) -> show every configured role's tab, including
      // empty placeholders, so testers can see what's still pending.
      // Scenario 2: cycle fully closed (every configured role reviewed) ->
      // show only tabs for roles that actually exist here, no placeholders.
      //
      // Roster is read from the cycle's OWN contract snapshot
      // (appraisalinformation, frozen at contract-creation time), not today's
      // live config — a role added after this cycle already closed must not
      // retroactively show up here just because it's active today.
      const clickedRoleSnapshot = appraisalRecord?.appraisalinformation;
      const cycleRoleSnapshot =
        Array.isArray(clickedRoleSnapshot) && clickedRoleSnapshot.length > 0
          ? clickedRoleSnapshot
          : contractSource?.find(
            (item) =>
              Array.isArray(item?.appraisalinformation) &&
              item.appraisalinformation.length > 0
          )?.appraisalinformation;

      const liveRoster =
        userList?.find((item) => item?.userid === appraisalRecord?.userid)
          ?.appraisalInformation || [];
      // A role toggled to "No" (or deleted) after this cycle's contract was
      // created must not keep showing a pending placeholder — it's been
      // actively turned off, not just "not yet created".
      const liveYesRoleTypes = new Set(
        liveRoster
          .filter((role) => role?.appraisal === "Yes")
          .map((role) => (role?.roletype || "").trim().toLowerCase())
      );

      // The cohort locks when the cycle is DONE, not at its first review. While
      // any contract here is still unreviewed the cycle is running, so a role
      // added now legitimately belongs to it — read the live roster. Once every
      // contract is reviewed the cycle is settled and the frozen snapshot takes
      // over, so later roster edits can't rewrite a closed cycle.
      const cycleFullyReviewed =
        filteredReference?.length > 0 &&
        filteredReference.every((c) => c?.contractstatus === "reviewed");

      // When the cycle is closed we still can't rely on the frozen snapshot
      // ALONE: a role added mid-cycle that never got a contract is absent from
      // the snapshot, so it would never even be considered for a tab. Union the
      // snapshot with the live roster (snapshot first, live roles appended if not
      // already present) so such a role is evaluated; the filter below then keeps
      // it only if it isn't a genuine after-close re-add. While the cycle is open
      // the live roster already covers everything.
      const rosterSource =
        cycleFullyReviewed &&
          Array.isArray(cycleRoleSnapshot) &&
          cycleRoleSnapshot.length > 0
          ? (() => {
            const byType = new Map();
            cycleRoleSnapshot.forEach((r) =>
              byType.set((r?.roletype || "").trim().toLowerCase(), r)
            );
            (liveRoster || []).forEach((r) => {
              const k = (r?.roletype || "").trim().toLowerCase();
              if (!byType.has(k)) byType.set(k, r);
            });
            return [...byType.values()];
          })()
          : liveRoster;

      // Cutoff for "re-added after the cycle closed". A role deleted and added
      // back after the cycle finished is a fresh joiner for a LATER cycle, not a
      // pending member here, so it must not render a blank placeholder tab.
      //
      // Only meaningful once the cycle is GENUINELY closed. filteredReference
      // covers only the contracts that EXIST in this cycle, so "every reviewed"
      // is true even when a cohort role never reached this cycle. A genuine
      // laggard — a live "Yes" role with no contract here that was NEVER deleted
      // (so it's been continuously present, just hasn't caught up) — means the
      // cycle is still running. Using one finished sibling's review time as the
      // cutoff then wrongly hides a churned laggard (a real member that was
      // deleted + re-added while still owing this cycle). Only the delete history
      // separates that laggard from a true after-close re-add.
      const hasGenuineLaggardHere = (liveRoster || []).some((role) => {
        if (role?.appraisal !== "Yes") return false;
        const rt = (role?.roletype || "").trim().toLowerCase();
        const hasContractHere = contractSource?.some(
          (c) => (c?.appraiseeroletype || "").trim().toLowerCase() === rt
        );
        if (hasContractHere) return false;
        const wasEverDeleted = (rosterHistoryList || []).some(
          (h) =>
            (h?.roletype || "").trim().toLowerCase() === rt &&
            h?.change === "Row deleted"
        );
        return !wasEverDeleted;
      });
      const cycleReviewedAt =
        cycleFullyReviewed && !hasGenuineLaggardHere
          ? getLatestReviewedAt(filteredReference)
          : 0;

      const employeeRoleTypes = (rosterSource || []).filter((role) => {
        const roleType = role?.roletype;
        const hasContractHere = contractSource?.some(
          (item) =>
            item?.appraiseeroletype?.trim().toLowerCase() ===
            (roleType || "").trim().toLowerCase()
        );
        // A role with an actual contract in this cycle always shows — it
        // genuinely participated (§12A.1 rule 1: hasContractHere wins), even if
        // it was later removed from the live roster.
        if (hasContractHere) return true;
        // No contract here: it only belongs if it's still an active roster role.
        if (
          role?.appraisal !== "Yes" ||
          !liveYesRoleTypes.has((roleType || "").trim().toLowerCase())
        ) {
          return false;
        }
        // Active but contract-less: drop it only if it was re-added AFTER the
        // cycle closed (a next-cycle joiner). A role added mid-cycle sits before
        // the last review, so it survives and shows as a pending placeholder.
        if (
          isReEnabledAfterCycleClosed(rosterHistoryList, roleType, cycleReviewedAt)
        ) {
          return false;
        }
        return true;
      });

      // An older cycle (already superseded by a later one) is always treated
      // as closed regardless of role completeness — a role missing from an
      // old cycle didn't participate, it isn't "still pending".
      const globalMaxPid = performanceContractList?.reduce(
        (max, c) => Math.max(max, Number(c?.performanceid) || 0),
        0
      );
      const isLatestCycle =
        Number(appraisalRecord?.performanceid) === globalMaxPid;

      const isCycleClosed =
        !isLatestCycle ||
        (employeeRoleTypes?.length > 0 &&
          employeeRoleTypes.every((role) =>
            filteredReference?.some(
              (item) =>
                item?.appraiseeroletype?.trim().toLowerCase() ===
                role?.roletype?.trim().toLowerCase() &&
                item?.contractstatus === "reviewed"
            )
          ));

      const missingRoleTypes = employeeRoleTypes?.filter(
        (role) =>
          !contractSource?.some(
            (item) =>
              item?.appraiseeroletype?.trim().toLowerCase() ===
              role?.roletype?.trim().toLowerCase()
          )
      );

      const segmentedData =
        !isEdit && !isCycleClosed
          ? [
            ...(contractSource?.map((item) => ({
              roletype: item?.appraiseeroletype,
              contractid: item.contractid,
            })) || []),
            ...(missingRoleTypes?.map((role) => ({
              roletype: role?.roletype,
              contractid: undefined,
            })) || []),
          ]
          : contractSource?.map((item) => ({
            roletype: item?.appraiseeroletype,
            contractid: item.contractid,
          }));

      const sortedSegmentedData = [...(segmentedData || [])].sort((a, b) => {
        if (a.contractid === appraisalRecord.contractid) return -1;
        if (b.contractid === appraisalRecord.contractid) return 1;
        const roleA = a.roletype?.toLowerCase() || "";
        const roleB = b.roletype?.toLowerCase() || "";
        if (roleA === "primary" && roleB !== "primary") return -1;
        if (roleB === "primary" && roleA !== "primary") return 1;
        const numberA = parseInt(roleA.match(/\d+/)?.[0], 10) || 0;
        const numberB = parseInt(roleB.match(/\d+/)?.[0], 10) || 0;
        return numberA - numberB;
      });

      setSegmentData(isEdit ? sortedSegmentedData : sortedSegmentedData);
      setSelectedSegment(
        sortedSegmentedData[0]?.contractid ??
        `empty-${sortedSegmentedData[0]?.roletype}`
      );
      setSelectedEmployee(
        userList?.find((item) => item?.userid === appraisalRecord?.userid)
      );
      setLoading(false);
    }
  };
  useEffect(() => {
    const filtered = allAppraisalData?.filter(
      (item) => item?.contractid === selectedSegment
    );
    setAppraisalDetails(filtered[0]);
    setSoftSkillData(
      filtered[0]?.softskills?.map((item, index) => {
        return { ...item, id: index + 1 };
      })
    );
    setTechnicalAssessmentData(filtered[0]?.technicalassessment);
    setRolledoverData(filtered[0]?.rolledovernextappraisal);
    if (filtered[0]?.appraiseescareergrowth?.length > 0) {
      setAppraiseeGrowthData(filtered[0]?.appraiseescareergrowth);
    }

    setFormValues(filtered[0]?.successionplanning);
  }, [selectedSegment, allAppraisalData]);

  const handleNext = () => {
    if (handleDataValidation() && handleValidation()) {
      setTabId(tabId + 1);
      layoutContentRef.current?.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleSegmentChange = (value) => {
    // const index = appraisalInformation?.findIndex(
    //   (item) => item.roletype === value
    // );
    // setSelectedSegment(value);
    // setAppraisalIndex(index + 1);
    // setCompletedSegment((prev) => {
    //   if (!prev.includes(index)) {
    //     return [...prev, index - 1];
    //   }
    //   return prev;
    // });
  };

  useEffect(() => {
    getDetails();
    getData();
  }, [appraisalRecord?.contractid]);

  const nextAppraisalSubmit = async (values, status) => {
    setLoading(true);
    // setFormValues([
    //   {
    //     ...formValues?.[0],
    //     appraisercomment: values?.appraisercomment,
    //     appraiserremark: values?.appraiserremark,
    //     appraiserremarknext: values?.appraiserremarknext,
    //   },
    // ]);
    const payload = {
      technicalassessment: technicalAssessmentData,
      softskills: softSkillData?.length > 0 ? softSkillData : [],
      appraiseescareergrowth:
        appraiseeGrowthData?.length > 0 ? appraiseeGrowthData : [],
      successionplanning: formValues,
      strategicobjectives: [],
      reviewedby: userInfo?.userid,
      averagesoftscore:
        softSkillData?.length > 0
          ? softSkillData?.reduce(
            (sum, skill) => sum + Number(skill.appraiserscore || 0),
            0
          ) / softSkillData?.length
          : 0,
      averagetechnicalscore:
        technicalAssessmentData?.length > 0
          ? technicalAssessmentData?.reduce(
            (sum, skill) => sum + Number(skill.appraiserscore || 0),
            0
          ) / technicalAssessmentData?.length
          : 0,
      rolledovernextappraisal: rolledOverData?.length > 0 ? rolledOverData : [],
      overallrating: [],
      contractstatus: status,
      reviewedon: new Date().toISOString(),
      appraiseemailid: appraisalDetails?.appraiseemailid,
      status: isEdit ? false : true,
    };
    const { code } = await CALL_API(
      `appraisal/${appraisalDetails?.attendid}/${appraisalDetails?.contractid}`,
      "patch",
      payload
    );
    if (code === "SUCCESS") {
      status === "draft"
        ? message.success("Draft submitted successfully")
        : message.success("Appraisal Closed successfully");
      history.push({
        pathname: "/performancemanagement",
        state: {
          tabId: isMyTeam ? "managerappraisal" : "mineappraisal",
          selectedItem: "performance-management",
        },
      });
      setLoading(false);
    } else {
      message.error("Failed to submit appraisal");
      setLoading(false);
    }
  };

  const footerStyle = {
    position: "sticky",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  const mergedHistoryData = historyData
    ?.filter(
      (item) =>
        item.contractid === appraisalDetails?.contractid &&
        item.contractstatus !== "draft"
    )
    ?.reduce((acc, item) => {
      Object.entries(item).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
      });
      return acc;
    }, {});

  const contractStatus = appraisalDetails?.contractstatus;
  let historydate = null;
  let dateLabel = "";

  if (
    contractStatus === "created" ||
    contractStatus === "resend" ||
    contractStatus === "updated"
  ) {
    historydate = mergedHistoryData?.createdon;
    dateLabel = "Created on:";
  } else if (contractStatus === "attended") {
    historydate = mergedHistoryData?.attendedon;
    dateLabel = "Attended on:";
  } else if (contractStatus === "accepted") {
    historydate =
      mergedHistoryData?.accepteddeclinedon || mergedHistoryData?.createdon;
    dateLabel = "Accepted on:";
  } else if (contractStatus === "declined") {
    historydate =
      mergedHistoryData?.accepteddeclinedon || mergedHistoryData?.createdon;
    dateLabel = "Declined on:";
  } else if (contractStatus === "reviewed") {
    historydate = mergedHistoryData?.reviewedon;
    dateLabel = "Closed on:";
  }

  const appraisal = () => {
    history.push({
      pathname: "/performancemanagement",
      state: {
        tabId: isMyTeam ? "managerappraisal" : "mineappraisal",
        selectedItem: "performance-management",
      },
    });
  };

  // Get the data for the modal table
  const modalTableData = getObjectiveDataFromContract(
    objectiveModal.objective,
    objectiveModal.contract
  );

  const userAppraisalInfo = userList
    ?.find((val) => val?.userid === appraisalDetails?.appraiseemailid)
    ?.appraisalInformation?.filter(
      (item) => item?.roletype === appraisalDetails?.appraiseeroletype
    );

  const technicaltotal = (technicalAssessmentData || []).reduce(
    (sum, item) => sum + Number(item.appraiserscore || 0),
    0
  );
  const TotalSoftScore = (technicalAssessmentData || []).reduce(
    (sum, item) => sum + Number(item.selfscore || 0),
    0
  );
  const technicalavg = technicalAssessmentData?.length
    ? (technicaltotal / technicalAssessmentData.length).toFixed(2)
    : 0;
  const technicalSoftavg = technicalAssessmentData?.length
    ? (TotalSoftScore / technicalAssessmentData.length).toFixed(2)
    : 0;

  const softtotal = (softSkillData || []).reduce(
    (sum, item) => sum + Number(item.appraiserscore || 0),
    0
  );
  const softavg = softSkillData?.length
    ? (softtotal / softSkillData.length).toFixed(2)
    : 0;

  const softappraiseetotal = (softSkillData || []).reduce(
    (sum, item) => sum + Number(item.selfscore || 0),
    0
  );
  const softappraiseeavg = softSkillData?.length
    ? (softappraiseetotal / softSkillData.length).toFixed(2)
    : 0;

  const finduser = userList?.find((item) => item?.userid === userInfo?.userid);

  const findtimeZone = CountryTimezone?.filter(
    (item) => item?.country === finduser?.managingoffice[0]
  );

  return (
    <div ref={scrollRef} className="scroll-container">
      <Spin spinning={loader}>
        <StyledModal
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ flex: 1 }}>
                {getObjectiveModalConfig(objectiveModal.objective).title}
              </span>
              <span style={{ marginRight: 24 }}>
                <a
                  onClick={() => {
                    viewJobDescription();
                  }}
                  style={{
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "#1890ff",
                    fontWeight: "500",
                    textDecoration: "underline",
                  }}
                >
                  {viewLoading ? <LoadingOutlined /> : "Job Description"}
                </a>
              </span>
            </div>
          }
          open={objectiveModal.open}
          footer={null}
          onCancel={() =>
            setObjectiveModal({ open: false, objective: null, contract: null })
          }
          width={1000}
          borderRadius="8px"
        >
          <Spin spinning={modalLoading} size="large">
            {!modalLoading && (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid #eee", padding: 8 }}>
                      S.No
                    </th>
                    <th style={{ border: "1px solid #eee", padding: 8 }}>
                      {
                        getObjectiveModalConfig(objectiveModal.objective)
                          .secondCol
                      }
                    </th>
                    <th style={{ border: "1px solid #eee", padding: 8 }}>
                      Expected Outcome
                    </th>
                    <th style={{ border: "1px solid #eee", padding: 8 }}>
                      Target Date
                    </th>
                    <th style={{ border: "1px solid #eee", padding: 8 }}>
                      Weightage
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {modalTableData.length > 0 ? (
                    modalTableData.map((row, idx) => (
                      <tr key={idx}>
                        <td style={{ border: "1px solid #eee", padding: 8 }}>
                          {row.sno}
                        </td>
                        <td style={{ border: "1px solid #eee", padding: 8 }}>
                          {row.main}
                        </td>
                        <td style={{ border: "1px solid #eee", padding: 8 }}>
                          {row.expectedoutcome}
                        </td>
                        <td style={{ border: "1px solid #eee", padding: 8 }}>
                          {row.targetdate
                            ? dayjs(row.targetdate, "YYYY-MM-DD").format(
                              "DD-MM-YYYY"
                            )
                            : "-"}
                        </td>
                        <td style={{ border: "1px solid #eee", padding: 8 }}>
                          {row.weightage}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={5}
                        style={{ textAlign: "center", padding: 8 }}
                      >
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </Spin>
        </StyledModal>
        <div>
          {!isEdit &&
            appraisalDetails?.appraiseemailid !== userInfo?.userid && (
              <SegmentWrap
                options={segmentedData.map((item) => ({
                  label: item?.roletype,
                  value: item?.contractid ?? `empty-${item?.roletype}`,
                }))}
                value={selectedSegment}
                onChange={(value) => {
                  setSelectedSegment(value);
                  handleSegmentChange(value);
                }}
              />
            )}

          <Tabledata>
            <div className="Appraisal_first_tabledata">
              <span
                className="appraisalTitle cursor-pointer"
                // onClick={() =>
                //   history.push("/performancemanagement", {
                //     tabId: "managerappraisal",
                //   })
                // }
                onClick={() => appraisal()}
              >
                Performance Management
              </span>{" "}
              <RightOutlined className="Right_outlined" />
              {/* <span
                  className="appraisalSubTitle cursor-pointer"
                  onClick={() =>
                    history.push(`/viewmyteamAppraisal/${id}`, {
                      tabId: tab,
                      appraisalname: appraisalname,
                    })
                  }
                >
                  {appraisalname || "---"},
                </span> */}
              <span>
                {" "}
                {appraisalRecord?.fullname ||
                  appraisalRecord?.employeename ||
                  ""}
              </span>
            </div>
          </Tabledata>

          <>
            <h4 className="mt-2">
              {appraisalDetails?.contractstatus === "reviewed"
                ? "Closed"
                : appraisalDetails?.contractstatus === "created" ||
                  appraisalDetails?.contractstatus === "accepted"
                  ? "Awaiting Appraisee Response"
                  : allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) &&
                    (appraisalDetails?.contractstatus === "attended" ||
                      appraisalDetails?.contractstatus === "draft")
                    ? "Reviewing to Close"
                    : !allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) &&
                      (appraisalDetails?.contractstatus === "attended" ||
                        appraisalDetails?.contractstatus === "draft")
                      ? "Appraiser Review Pending"
                      : ""}
            </h4>
          </>

          {/* Date Button */}
          <ButtonFilled
            style={{
              position: "fixed",
              bottom: "60px",
              left: "320px",
              borderRadius: "25px",
              zIndex: 1000,
              cursor: "pointer",
              boxShadow:
                "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
            }}
            onClick={() => setIsModalOpen(true)}
          >
            {dayjs(
              mergedHistoryData?.contractstatus === "reviewed"
                ? mergedHistoryData?.reviewedon
                : mergedHistoryData?.contractstatus === "attended"
                  ? mergedHistoryData?.attendedon
                  : mergedHistoryData?.accepteddeclinedon
            ).isValid()
              ? `${mergedHistoryData?.contractstatus === "reviewed"
                ? "Closed on:"
                : mergedHistoryData?.contractstatus === "attended"
                  ? "Attended on:"
                  : mergedHistoryData?.contractstatus === "accepted"
                    ? "Accepted on:"
                    : mergedHistoryData?.contractstatus === "declined"
                      ? "Declined on:"
                      : mergedHistoryData?.contractstatus === "resend"
                        ? "Resent on:"
                        : mergedHistoryData?.contractstatus === "updated"
                          ? "Updated on:"
                          : mergedHistoryData?.contractstatus === "created"
                            ? "Created on:"
                            : "Attended on:"
              } ${dayjs(
                mergedHistoryData?.contractstatus === "reviewed"
                  ? mergedHistoryData?.reviewedon
                  : mergedHistoryData?.contractstatus === "attended"
                    ? mergedHistoryData?.attendedon
                    : mergedHistoryData?.contractstatus === "accepted"
                      ? mergedHistoryData?.accepteddeclinedon
                      : mergedHistoryData?.contractstatus === "declined"
                        ? mergedHistoryData?.accepteddeclinedon
                        : mergedHistoryData?.contractstatus === "resend"
                          ? mergedHistoryData?.updatedon
                          : mergedHistoryData?.contractstatus === "updated"
                            ? mergedHistoryData?.updatedon
                            : mergedHistoryData?.contractstatus === "created"
                              ? mergedHistoryData?.createdon
                              : mergedHistoryData?.attendedon
              )
                .utc()
                .tz("Africa/Nairobi")
                .format("D MMM YYYY, hh:mm A")}`
              : "Accepted on : -"}
          </ButtonFilled>
          {/* Floating User Icon */}
          <img
            src={user}
            alt="Floating User Icon"
            style={{
              position: "fixed",
              bottom: "50px",
              right: "50px",
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              zIndex: 1000,
              cursor: "pointer",
            }}
            onClick={showModal}
          />

          {/* Modal */}
          <AppraisalHistory
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            appraiseeid={appraisalRecord[0]?.userid}
            data={historyData?.filter(
              (item) =>
                item.contractid === appraisalDetails?.contractid &&
                item.contractstatus !== "draft"
            )}
            title="Contract History"
          />
          <Spin spinning={loading}>
            {!allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: 300,
                }}
              >
                {appraisalDetails?.contractstatus === "attended" ? (
                  <>
                    <FolderIconYellow style={{ width: 200, height: 200, marginBottom: 10 }} />{" "}
                    <p style={{ fontSize: 18, color: "#999", textAlign: "center" }}>
                      {" "}
                      The Appraiser(s) haven't Reviewed the appraisal yet
                    </p>
                  </>
                ) : (
                  <>
                    <FolderIconYellow style={{ width: 200, height: 200, marginBottom: 10 }} />{" "}
                    <p style={{ fontSize: 18, color: "#999", textAlign: "center" }}>
                      {" "}
                      No appraisal created for this role yet
                    </p>
                  </>
                )}
              </div>
            )}
            {allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) && appraisalDetails?.contractstatus !== "contractdraft" && (

              <>
                {/* Not attended yet — there is no assessment to show. Without this
                  branch a created/accepted contract fell through to the
                  scorecard grid and rendered an empty table with "Average
                  Score: 0", which reads as a zero score rather than "no score
                  yet". These contracts only reach this component now that the
                  API returns unattended ones. */}
                {!isEdit &&
                  (appraisalDetails?.contractstatus === "created" ||
                    appraisalDetails?.contractstatus === "accepted") ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 300,
                    }}
                  >
                    <Empty description="Awaiting Appraisee Response" />
                  </div>
                ) : !isEdit && (appraisalDetails?.contractstatus === "attended" || appraisalDetails?.contractstatus === "draft") ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 300,
                    }}
                  >
                    <Empty description="Appraiser Review Pending" />
                  </div>
                ) : appraisalDetails?.appraiseeroletype !== "Primary" ? (
                  <Tabledata>
                    {/* <AppraisalForm appraisalDetails={appraisalDetails} /> */}
                    <h6>
                      Employee Scorecard - Power BI -{" "}
                      <a
                        href="https://app.powerbi.com/groups/630f8390-9880-4177-929b-7bd91f0bedfe/reports/3d76a0ac-948e-454b-bf3b-75e04b2d3f5c/d45f4930a7bc58596021?experience=power-bi"
                        id="m_-8402443038962109074m_-6895529901520386798OWAb5b7a0de-4f34-011d-612c-0f428cd224db"
                        target="_blank"
                        data-saferedirecturl="https://www.google.com/url?q=https://app.powerbi.com/groups/630f8390-9880-4177-929b-7bd91f0bedfe/reports/3d76a0ac-948e-454b-bf3b-75e04b2d3f5c/d45f4930a7bc58596021?experience%3Dpower-bi&amp;source=gmail&amp;ust=1751024712172000&amp;usg=AOvVaw3TFhX25zyjt-Ip9o8oqWYh"
                      >
                        Employee Scorecard - Power BI
                      </a>
                    </h6>
                    <div
                      className="mt-4"
                      style={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <div>
                        <b>Technical Assessments</b>
                      </div>
                      <Wrap>
                        <div>
                          <p
                            className="score-classification"
                            type="link"
                            onClick={() => setIsScoreModal(true)}
                          >
                            Score Classification
                          </p>
                        </div>
                      </Wrap>
                    </div>
                    <StyledTable
                      columns={columns}
                      dataSource={technicalAssessmentData || []}
                      className="custom-table"
                      size="middle"
                      pagination={false}
                      summary={() => (
                        <Table.Summary.Row>
                          <Table.Summary.Cell index={0} colSpan={3}>
                            <b></b>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={3}>
                            <div
                              style={{
                                backgroundColor: "#fafafa",
                                padding: "10px",
                              }}
                            >
                              <strong> Average Score:</strong>{" "}
                              <b>{technicalSoftavg || 0}</b>
                            </div>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={4}>
                            <div
                              style={{
                                backgroundColor: "#fafafa",
                                padding: "10px",
                              }}
                            >
                              <strong>Appraiser’s Average:</strong>{" "}
                              <b>{technicalavg || 0}</b>
                            </div>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                    />
                    <br />
                    <NextAppraisal
                      userInfo={userInfo}
                      appraisalRecord={appraisalRecord}
                      appraisalDetails={appraisalDetails}
                      selectedSegment={selectedSegment}
                      rolledOverData={rolledOverData}
                      setRolledoverData={setRolledoverData}
                      setValidationRoleOverErrors={setValidationRoleOverErrors}
                      validationRollOverErrors={validationRollOverErrors}
                      formValues={formValues}
                      setFormValues={setFormValues}
                      nextAppraisalSubmit={nextAppraisalSubmit}
                      setAppraisarGrowthValidationErrors={
                        setAppraisarGrowthValidationErrors
                      }
                      appraisarGrowthValidationErrors={
                        appraisarGrowthValidationErrors
                      }
                      tabId={tabId}
                      setTabId={setTabId}
                      activeTabId={activeTabId}
                      id={id}
                      appraiseeGrowthData={appraiseeGrowthData}
                      setAppraiseeGrowthData={setAppraiseeGrowthData}
                      loading={loading}
                      isEdit={isEdit}
                      isView={isView}
                      draftLoading={draftLoading}
                    />
                  </Tabledata>
                ) : (
                  <>
                    {isEdit && (
                      <StepsProgress step={tabId - 1} stepdata={stepdata} />
                    )}

                    {/* ── VIEW MODE: My Team → Primary → Closed (tabbed) ── */}
                    {!isEdit && (
                      <Tabledata>
                        {/* Tab bar: only for My Team (isMyTeam=true). Mine pages render flat without tabs */}
                        {isMyTeam && (
                          <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                            padding: "0px",
                            gap: "32px",
                            borderBottom: "2px solid #E2E2E8",
                            marginBottom: "24px",
                          }}>
                            {[
                              { key: "basic", label: "Basic Evaluation" },
                              { key: "recommendations", label: "Recommendations" },
                            ].map((tab) => {
                              const isActive = myTeamViewTab === tab.key;
                              return (
                                <div
                                  key={tab.key}
                                  onClick={() => setMyTeamViewTab(tab.key)}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    padding: "0px",
                                    gap: "6px",
                                    cursor: "pointer",
                                    marginBottom: "-2px",
                                  }}
                                >
                                  <span style={{
                                    fontFamily: "'DM Sans', sans-serif",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    lineHeight: "21px",
                                    color: isActive ? "#1F243B" : "#636980",
                                  }}>
                                    {tab.label}
                                  </span>
                                  <div style={{
                                    width: "100%",
                                    height: "0px",
                                    border: `1px solid ${isActive ? "#1F243B" : "#636980"}`,
                                    opacity: isActive ? 1 : 0,
                                  }} />
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {/* ── Tab 1: Basic Evaluation (My Team) OR full flat view (Mine) ──
                          Sections: Technical Assessment, Soft Skills / BDO VALUES, Succession Planning */}
                        {(!isMyTeam || myTeamViewTab === "basic") && (
                          <>
                            <h6>
                              Employee Scorecard - Power BI -{" "}
                              <a
                                href="https://app.powerbi.com/groups/630f8390-9880-4177-929b-7bd91f0bedfe/reports/3d76a0ac-948e-454b-bf3b-75e04b2d3f5c/d45f4930a7bc58596021?experience=power-bi"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Employee Scorecard - Power BI
                              </a>
                            </h6>
                            <div style={{ background: "#f8f8f8", borderRadius: "12px", padding: "20px", marginTop: "24px" }}>
                              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                                <div><b>Technical Assessment</b></div>
                                <Wrap>
                                  <p className="score-classification" onClick={() => setIsScoreModal(true)}>
                                    Score Classification
                                  </p>
                                </Wrap>
                              </div>
                              <StyledTable
                                columns={columns}
                                dataSource={technicalAssessmentData || []}
                                className="custom-table"
                                size="middle"
                                pagination={false}
                                summary={() => (
                                  <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} colSpan={3}><b></b></Table.Summary.Cell>
                                    <Table.Summary.Cell index={3}>
                                      <div style={{ backgroundColor: "#fafafa", padding: "10px" }}>
                                        <strong>Average Score:</strong> <b>{technicalSoftavg || 0}</b>
                                      </div>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={4}>
                                      <div style={{ backgroundColor: "#fafafa", padding: "10px" }}>
                                        <strong>Appraiser's Average:</strong> <b>{technicalavg || 0}</b>
                                      </div>
                                    </Table.Summary.Cell>
                                  </Table.Summary.Row>
                                )}
                              />
                            </div>
                            <div style={{ background: "#f8f8f8", borderRadius: "12px", padding: "20px", marginTop: "24px" }}>
                              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                                <div><b>Individual ( Soft skils ) Assessment / BDO VALUES</b></div>
                                <Wrap>
                                  <p className="score-classification" onClick={() => setIsScoreModal(true)}>
                                    Score Classification
                                  </p>
                                </Wrap>
                              </div>
                              <StyledTable
                                columns={columns1}
                                dataSource={softSkillData || []}
                                className="custom-table"
                                size="middle"
                                pagination={false}
                                summary={() => (
                                  <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} colSpan={4}><b></b></Table.Summary.Cell>
                                    <Table.Summary.Cell index={4}>
                                      <div style={{ backgroundColor: "#fafafa", padding: "10px" }}>
                                        <strong>Average Score:</strong> <b>{softappraiseeavg || 0}</b>
                                      </div>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={5}>
                                      <div style={{ backgroundColor: "#fafafa", padding: "10px" }}>
                                        <strong>Appraiser's Average:</strong> <b>{softavg || 0}</b>
                                      </div>
                                    </Table.Summary.Cell>
                                  </Table.Summary.Row>
                                )}
                              />
                            </div>
                            {/* My Team Tab 1: Succession Planning only.
                              Mine (flat): NextAppraisal with hideSuccession=false renders everything */}
                            <NextAppraisal
                              userInfo={userInfo}
                              appraisalRecord={appraisalRecord}
                              appraisalDetails={appraisalDetails}
                              selectedSegment={selectedSegment}
                              rolledOverData={rolledOverData}
                              setRolledoverData={setRolledoverData}
                              setValidationRoleOverErrors={setValidationRoleOverErrors}
                              validationRollOverErrors={validationRollOverErrors}
                              formValues={formValues}
                              setFormValues={setFormValues}
                              nextAppraisalSubmit={nextAppraisalSubmit}
                              setAppraisarGrowthValidationErrors={setAppraisarGrowthValidationErrors}
                              appraisarGrowthValidationErrors={appraisarGrowthValidationErrors}
                              tabId={tabId}
                              setTabId={setTabId}
                              activeTabId={activeTabId}
                              id={id}
                              appraiseeGrowthData={appraiseeGrowthData}
                              setAppraiseeGrowthData={setAppraiseeGrowthData}
                              loading={loading}
                              isEdit={isEdit}
                              isView={isView}
                              draftLoading={draftLoading}
                              successionOnly={isMyTeam}
                              hideSuccession={false}
                            />
                          </>
                        )}

                        {/* ── Tab 2: Recommendations (My Team only) ──
                          Sections: Responsibilities Rolled Over, Career Growth Recommendations, Overall Rating / Comments */}
                        {isMyTeam && myTeamViewTab === "recommendations" && (
                          <NextAppraisal
                            userInfo={userInfo}
                            appraisalRecord={appraisalRecord}
                            appraisalDetails={appraisalDetails}
                            selectedSegment={selectedSegment}
                            rolledOverData={rolledOverData}
                            setRolledoverData={setRolledoverData}
                            setValidationRoleOverErrors={setValidationRoleOverErrors}
                            validationRollOverErrors={validationRollOverErrors}
                            formValues={formValues}
                            setFormValues={setFormValues}
                            nextAppraisalSubmit={nextAppraisalSubmit}
                            setAppraisarGrowthValidationErrors={setAppraisarGrowthValidationErrors}
                            appraisarGrowthValidationErrors={appraisarGrowthValidationErrors}
                            tabId={tabId}
                            setTabId={setTabId}
                            activeTabId={activeTabId}
                            id={id}
                            appraiseeGrowthData={appraiseeGrowthData}
                            setAppraiseeGrowthData={setAppraiseeGrowthData}
                            loading={loading}
                            isEdit={isEdit}
                            isView={isView}
                            draftLoading={draftLoading}
                            hideSuccession={true}
                          />
                        )}
                      </Tabledata>
                    )}

                    {/* ── EDIT MODE STEP 1 ── */}
                    {isEdit && tabId === 1 && (
                      <Tabledata>
                        <h6>
                          Employee Scorecard - Power BI -{" "}
                          <a
                            href="https://app.powerbi.com/groups/630f8390-9880-4177-929b-7bd91f0bedfe/reports/3d76a0ac-948e-454b-bf3b-75e04b2d3f5c/d45f4930a7bc58596021?experience=power-bi"
                            id="m_-8402443038962109074m_-6895529901520386798OWAb5b7a0de-4f34-011d-612c-0f428cd224db"
                            target="_blank"
                            data-saferedirecturl="https://www.google.com/url?q=https://app.powerbi.com/groups/630f8390-9880-4177-929b-7bd91f0bedfe/reports/3d76a0ac-948e-454b-bf3b-75e04b2d3f5c/d45f4930a7bc58596021?experience%3Dpower-bi&amp;source=gmail&amp;ust=1751024712172000&amp;usg=AOvVaw3TFhX25zyjt-Ip9o8oqWYh"
                          >
                            Employee Scorecard - Power BI
                          </a>
                        </h6>
                        <div
                          className="mt-4"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <b>Technical Assessment</b>
                          </div>
                          <Wrap>
                            <div>
                              <p
                                className="score-classification"
                                type="link"
                                onClick={() => setIsScoreModal(true)}
                              >
                                Score Classification
                              </p>
                            </div>
                          </Wrap>
                        </div>
                        <StyledTable
                          columns={columns}
                          dataSource={technicalAssessmentData || []}
                          className="custom-table"
                          size="middle"
                          pagination={false}
                          //loading={loading}
                          summary={() => (
                            <Table.Summary.Row>
                              <Table.Summary.Cell index={0} colSpan={3}>
                                <b></b>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell index={3}>
                                <div
                                  style={{
                                    backgroundColor: "#fafafa",
                                    padding: "10px",
                                  }}
                                >
                                  <strong> Average Score:</strong>{" "}
                                  <b>{technicalSoftavg || 0}</b>
                                </div>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell index={4}>
                                <div
                                  style={{
                                    backgroundColor: "#fafafa",
                                    padding: "10px",
                                  }}
                                >
                                  <strong>Appraiser’s Average:</strong>{" "}
                                  <b>{technicalavg || 0}</b>
                                </div>
                              </Table.Summary.Cell>
                            </Table.Summary.Row>
                          )}
                        />

                        <br />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <b>
                              Individual ( Soft skils ) Assessment / BDO VALUES
                            </b>
                          </div>
                          <Wrap>
                            <div>
                              <p
                                className="score-classification"
                                type="link"
                                onClick={() => setIsScoreModal(true)}
                              >
                                Score Classification
                              </p>
                            </div>
                          </Wrap>
                        </div>
                        <StyledTable
                          columns={columns1}
                          dataSource={softSkillData || []}
                          className="custom-table"
                          size="middle"
                          pagination={false}
                          //loading={loading}
                          summary={() => (
                            <Table.Summary.Row>
                              <Table.Summary.Cell index={0} colSpan={4}>
                                <b></b>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell index={4}>
                                <div
                                  style={{
                                    backgroundColor: "#fafafa",
                                    padding: "10px",
                                  }}
                                >
                                  <strong>Average Score:</strong>{" "}
                                  <b>{softappraiseeavg || 0}</b>
                                </div>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell index={5}>
                                <div
                                  style={{
                                    backgroundColor: "#fafafa",
                                    padding: "10px",
                                  }}
                                >
                                  <strong>Appraiser’s Average:</strong>{" "}
                                  <b>{softavg || 0}</b>
                                </div>
                              </Table.Summary.Cell>
                            </Table.Summary.Row>
                          )}
                        />

                        <br />

                        {/* Step 1: Show only Succession Planning section */}
                        <NextAppraisal
                          userInfo={userInfo}
                          appraisalRecord={appraisalRecord}
                          appraisalDetails={appraisalDetails}
                          selectedSegment={selectedSegment}
                          rolledOverData={rolledOverData}
                          setRolledoverData={setRolledoverData}
                          setValidationRoleOverErrors={setValidationRoleOverErrors}
                          validationRollOverErrors={validationRollOverErrors}
                          formValues={formValues}
                          setFormValues={setFormValues}
                          nextAppraisalSubmit={nextAppraisalSubmit}
                          setAppraisarGrowthValidationErrors={setAppraisarGrowthValidationErrors}
                          appraisarGrowthValidationErrors={appraisarGrowthValidationErrors}
                          tabId={tabId}
                          setTabId={setTabId}
                          activeTabId={activeTabId}
                          id={id}
                          appraiseeGrowthData={appraiseeGrowthData}
                          setAppraiseeGrowthData={setAppraiseeGrowthData}
                          loading={loading}
                          isEdit={isEdit}
                          isView={isView}
                          draftLoading={draftLoading}
                          successionOnly={true}
                        />

                        {/* Step 1 Footer: Cancel + Save as Draft + Next */}
                        {!isView && (
                          <div style={footerStyle}>
                            <ButtonOutlined
                              style={{ width: "130px" }}
                              onClick={() => appraisal()}
                            >
                              Cancel
                            </ButtonOutlined>
                            <ButtonOutlined
                              style={{ width: "150px" }}
                              loading={draftLoading}
                              onClick={() => nextAppraisalSubmit({}, "draft")}
                            >
                              Save as Draft
                            </ButtonOutlined>
                            <ButtonFilled
                              style={{ width: "130px" }}
                              onClick={handleNext}
                            >
                              Next
                            </ButtonFilled>
                          </div>
                        )}
                      </Tabledata>
                    )}
                    {/* ── EDIT MODE STEP 2 ── */}
                    {isEdit && tabId === 2 && (
                      <>
                        <NextAppraisal
                          userInfo={userInfo}
                          appraisalRecord={appraisalRecord}
                          appraisalDetails={appraisalDetails}
                          selectedSegment={selectedSegment}
                          rolledOverData={rolledOverData}
                          setRolledoverData={setRolledoverData}
                          setValidationRoleOverErrors={
                            setValidationRoleOverErrors
                          }
                          validationRollOverErrors={validationRollOverErrors}
                          formValues={formValues}
                          setFormValues={setFormValues}
                          nextAppraisalSubmit={nextAppraisalSubmit}
                          setAppraisarGrowthValidationErrors={
                            setAppraisarGrowthValidationErrors
                          }
                          appraisarGrowthValidationErrors={
                            appraisarGrowthValidationErrors
                          }
                          tabId={tabId}
                          setTabId={setTabId}
                          activeTabId={activeTabId}
                          id={id}
                          appraiseeGrowthData={appraiseeGrowthData}
                          setAppraiseeGrowthData={setAppraiseeGrowthData}
                          loading={loading}
                          isEdit={isEdit}
                          isView={isView}
                          draftLoading={draftLoading}
                          hideSuccession={true}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {allAppraisalData?.some(item => String(item?.contractid) === String(selectedSegment)) && appraisalDetails?.contractstatus === "contractdraft" && (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 300,
                  }}
                >
                  <FolderIcon
                    style={{ width: 200, height: 200, marginBottom: 10 }}
                  />{" "}
                  <p style={{ fontSize: 18, color: "#999", textAlign: "center" }}>
                    {" "}
                    The Appraiser(s) haven't Created the appraisal yet
                  </p>
                </div>
              </>
            )}
          </Spin>
        </div>

        <StyledModal
          title="Score Classification"
          open={isScoreModal}
          footer={null}
          onCancel={() => setIsScoreModal(false)}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              borderRadius: "8px",
            }}
          >
            <tbody>
              {scoreData?.map((item, index) => (
                <tr
                  key={index}
                  style={{ backgroundColor: item.color, color: "#fff" }}
                >
                  <td className="item-score">{item.score}</td>
                  <td className="item-description">{item.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </StyledModal>
        <EmployeeInfo
          isModalVisible={isModalVisible}
          handleCancelModal={handleCancelModal}
          selectedEmployee={findUser}
        />
        <Modal
          open={isPdfModalOpen}
          onCancel={() => setIsPdfModalOpen(false)}
          footer={null}
          width={1000}
          centered
          bodyStyle={{ height: "80vh", padding: 0 }}
        >
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          ) : (
            <p style={{ textAlign: "center", paddingTop: "40%" }}>Loading...</p>
          )}
        </Modal>
      </Spin>
    </div>
  );
};
const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  userList: getUserList(state),
});

export default connect(mapStateToProps)(Viewmytabledata);